module.exports = __webpack_public_path__ + "img/neighbor-1-bg.e2d57144.jpg";